import {
	EVENT_ACTION_PARKING_OPTIONS_PROMOTION_INVALID,
	EVENT_ACTION_PARKING_OPTIONS_PROMOTION_SUCCESS,
	EVENT_CATEGORY_PARKING_OPTIONS,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackPromotionResult(promoCode: string, isValid: boolean) {
	if (isValid) {
		trackCustomEvent({
			category: EVENT_CATEGORY_PARKING_OPTIONS,
			action: EVENT_ACTION_PARKING_OPTIONS_PROMOTION_SUCCESS,
			label: promoCode,
		});
	} else {
		trackCustomEvent({
			category: EVENT_CATEGORY_PARKING_OPTIONS,
			action: EVENT_ACTION_PARKING_OPTIONS_PROMOTION_INVALID,
			label: promoCode,
		});
	}
}
